import React, {PropsWithChildren} from 'react';
import {makeStyles} from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import ExtensionIcon from '@material-ui/icons/Extension';
import MapIcon from '@material-ui/icons/MyLocation';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import GitHubIcon from '@material-ui/icons/GitHub';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import LayersIcon from '@material-ui/icons/Layers';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import {SidebarSearchModal} from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const {isOpen} = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link
        to="/"
        underline="none"
        className={classes.link}
        aria-label="Home"
      >
        {isOpen ? <LogoFull/> : <LogoIcon/>}
      </Link>
    </div>
  );
};

export const Root = ({children}: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo/>
      <SidebarGroup label="Search" icon={<SearchIcon/>} to="/search">
        <SidebarSearchModal/>
      </SidebarGroup>
      <SidebarDivider/>
      <SidebarGroup label="Menu" icon={<MenuIcon/>}>
        {/* Global nav, not org-specific */}
        <SidebarItem icon={HomeIcon} to="catalog" text="Home"/>
        <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs"/>
        <SidebarItem icon={LibraryBooks} to="docs" text="Docs"/>
        <SidebarItem icon={CreateComponentIcon} to="create" text="Create..."/>
        <SidebarItem icon={LayersIcon} to="explore" text="Explore" />
        <SidebarItem icon={GitHubIcon} to="/grm" text="Release Manager" /> 
        {/* End global nav */}
        <SidebarDivider/>
        <SidebarScrollWrapper>
          <SidebarItem icon={MapIcon} to="tech-radar" text="Tech Radar"/>
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace/>
      <SidebarDivider/>
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar/>}
        to="/settings"
      >
        <SidebarSettings/>
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
